<template>
  <div>
    <PuzzleCaptchaComponent v-if="!muestraForm && !token" @complete="validarCaptcha" />
    <FormInicialComponent v-else :numberform="numberForm" />
  </div>
</template>

<script>
import FormInicialComponent from './FormInicial.vue'
import PuzzleCaptchaComponent from './puzzleCaptcha.vue'
import { resolveToken } from '../utils/tokenResolver'

export default {
  name: 'HomePage',
  components: { FormInicialComponent, PuzzleCaptchaComponent },
  data() {
    return {
      muestraForm: false,
      numberForm: 1,
      token: null
    };
  },
  mounted() {
    this.token = resolveToken(this.$route);
    if (this.token) {
      this.muestraForm = true;
      this.numberForm = 2;
      return;
    }
    this.muestraForm = sessionStorage.getItem('muestraForm') === 'true';
  },
  methods: {
    validarCaptcha(completo) {
      if (!completo) return;
      this.muestraForm = true;
      sessionStorage.setItem('muestraForm', 'true');
    }
  },
}
</script>
